module.exports = __webpack_public_path__ + "static/media/dress.e3e37adf.png";